import { FETCH_PINCODE_FAILURE, FETCH_PINCODE_REQUEST, FETCH_PINCODE_SUCCESS } from "../actions/types";

const initialState = {
    data: [],
    error: ''
};

export const posPinReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PINCODE_REQUEST:
            return {
                ...state,
            }
        case FETCH_PINCODE_SUCCESS:
            return {
                data: action.payload
            }
        case FETCH_PINCODE_FAILURE:
            return {
                data: [],
                error: action.payload
            }
        default:
            return state;
    }
}